"use strict";
exports.__esModule = true;
exports.fileExtension = void 0;
var firstMatch_1 = require("./firstMatch");
exports.fileExtension = firstMatch_1.firstMatch(/(?:[%_/.\w+-]+)(\.[\w]+)(?:[#?][\w./=]+)?/);
//# sourceMappingURL=fileExtension.js.map